import { useMutation, UseMutationResult } from 'react-query'

import { BlockedTypeEnum } from '@interfaces/BlockedTypeEnum'
import { useCommentAction } from './useCommentAction'

export function useBlockComment({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void
  onError?: () => void
}): UseMutationResult<
  any,
  unknown,
  {
    id: number
    blockType: BlockedTypeEnum
  },
  unknown
> {
  const commentClient = useCommentAction()

  return useMutation(
    (params: { id: number; blockType: BlockedTypeEnum }) =>
      commentClient.blockComment(params),
    {
      onSuccess,
      onError,
    }
  )
}
